module.exports = __webpack_public_path__ + "static/pcr18-stats-5a5971d1f86feafa61107e7357a5fb83.png";